import React, { lazy, Suspense, useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import Header from "./Header";
import Footer from "./Footer";
import StickyWhatsApp from "@/components/StickyWhatsApp";
import { CmsEditProvider } from "@/cms/CmsEditContext";
import { CmsEditBar } from "@/cms/CmsEditBar";
import { usePageViewTracker } from "@/hooks/usePageViewTracker";

const EbSmallsearchBar = lazy(() => import("@/components/EbSmallsearchBar"));
const PopupRenderer = lazy(() => import("@/components/PopupRenderer"));

const Layout: React.FC = () => {
  const { hash, pathname } = useLocation();
  usePageViewTracker();

  useEffect(() => {
    if (hash) return;
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  useEffect(() => {
    if (!hash) return;

    window.setTimeout(() => {
      const target = document.getElementById(decodeURIComponent(hash.slice(1)));
      target?.scrollIntoView({ block: "start" });
    }, 0);
  }, [hash]);

  return (
    <CmsEditProvider>
      <div className="flex min-h-screen flex-col">
        <a
          href="#main-content"
          className="sr-only focus:not-sr-only focus:absolute focus:z-[100] focus:top-2 focus:left-2 focus:px-4 focus:py-2 focus:bg-primary focus:text-primary-foreground focus:rounded-md focus:outline-none"
        >
          Zum Inhalt springen
        </a>

        {/* Organization & Hotel liegen bereits als @graph in index.html –
            kein zweiter Block, damit keine konkurrierenden Entitäten entstehen. */}


        <Header />
        <main id="main-content" className="flex-1 pt-[72px] lg:pt-[88px] 2xl:pt-[103px]">
          <Outlet />
        </main>
        <Footer />
        <StickyWhatsApp />
        <Suspense fallback={null}>
          <EbSmallsearchBar />
        </Suspense>
        <CmsEditBar />
        <Suspense fallback={null}>
          <PopupRenderer />
        </Suspense>
      </div>
    </CmsEditProvider>
  );
};

export default Layout;
